module.exports = __webpack_public_path__ + "img/ObsWhite.8927baeb.svg";